module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/empty-e576369624ae9dda98024c24c287c663.png";